import React from "react";
import { observer } from "mobx-react-lite";
import { ProfileScreenVMProvider } from "@screens/ProfileScreen/ProfileScreenVM";
import ProfileScreenImpl from "@screens/ProfileScreen/ProfileScreenImpl";

const ProfileScreen = () => {

  return (
    <ProfileScreenVMProvider>
      <ProfileScreenImpl />
    </ProfileScreenVMProvider>
  );
};

export default observer(ProfileScreen);
